export const MEMBER_INFO_CHANGED = 'MEMBER_INFO_CHANGED'
export const ADD_MEMBER = 'ADD_MEMBER'
export const REMOVE_MEMBER = 'REMOVE_FAMILY_MEMBER'
export const MEMBER_QUALIFY_LIFE_EVENT_CHANGED =
  'MEMBER_QUALIFY_LIFE_EVENT_CHANGED'
export const UPDATE_OWNER_MEMBER_EMAIL = 'UPDATE_OWNER_MEMBER_EMAIL'
export const MEMBERS_UPDATED = 'MEMBERS_UPDATED'
export const MEMBER_CHANGED = 'MEMBER_CHANGED'